import { render, staticRenderFns } from "./DemDetTariff.vue?vue&type=template&id=6921e04a"
import script from "./DemDetTariff.vue?vue&type=script&lang=js"
export * from "./DemDetTariff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6921e04a')) {
      api.createRecord('6921e04a', component.options)
    } else {
      api.reload('6921e04a', component.options)
    }
    module.hot.accept("./DemDetTariff.vue?vue&type=template&id=6921e04a", function () {
      api.rerender('6921e04a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/DemDetTariff.vue"
export default component.exports